import {
  FormattedMessage,
  MessageDescriptor,
  defineMessages,
} from 'react-intl';

import { FullWidthContainer } from 'atoms/layout/FullWidthContainer';
import { Tab, TabBar } from 'atoms/navigation/TabBar';
import { SEARCH_PARAMS } from 'components/search/InstantSearch/types';
import { buildFilterQuery } from 'components/search/InstantSearch/utils';
import { useSettlableWalletsSearch } from 'hooks/useSettlableWalletsSearch';
import { glossary, navLabels } from 'lib/glossary';

export type Props = {
  tabs: Partial<Record<PlayerPageTabs, { to: string; onClick?: () => void }>>;
};

export enum PlayerPageTabs {
  OVERVIEW = 'OVERVIEW',
  FIXTURES = 'FIXTURES',
  GAMES = 'GAMES',
  SUPPLY = 'SUPPLY',
  TRANSACTIONS = 'TRANSACTIONS',
  CARDS = 'CARDS',
}

const messages = defineMessages({
  supply: {
    id: 'Seo.Player.Header.Supply',
    defaultMessage: 'Supply',
  },
});

const tabsTitle: Record<PlayerPageTabs, MessageDescriptor> = {
  [PlayerPageTabs.OVERVIEW]: navLabels.overview,
  [PlayerPageTabs.FIXTURES]: navLabels.fixtures,
  [PlayerPageTabs.GAMES]: glossary.games,
  [PlayerPageTabs.SUPPLY]: messages.supply,
  [PlayerPageTabs.TRANSACTIONS]: glossary.transactions,
  [PlayerPageTabs.CARDS]: glossary.cards,
};

export const Tabs = ({ tabs }: Props) => {
  const { params } = useSettlableWalletsSearch();

  const tabsToDisplay = Object.keys(tabs) as PlayerPageTabs[];
  return (
    <FullWidthContainer.NoPadding>
      <TabBar variant="flat" fullWidth>
        {Object.values(tabsToDisplay).map(tab => (
          <Tab
            key={tab}
            to={
              tab === PlayerPageTabs.CARDS
                ? `${tabs[tab]?.to}?${buildFilterQuery({
                    [SEARCH_PARAMS.ON_SALE]: true,
                    [SEARCH_PARAMS.IN_SEASON]: true,
                    ...(params
                      ? { [SEARCH_PARAMS.PURCHASE_OPTIONS]: params }
                      : {}),
                  })}`
                : tabs[tab]?.to
            }
            onClick={tabs[tab]?.onClick}
          >
            <FormattedMessage {...tabsTitle[tab]} />
          </Tab>
        ))}
      </TabBar>
    </FullWidthContainer.NoPadding>
  );
};
